<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">تعديل الاعلان</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="updateSelectedBanner">
              <div class="card-body__form">
                <div class="row">
                  <div class="col-12">
                    <!-- Banner Type -->
                    <div class="form-group">
                      <label for="banner_type">نوع الاعلان</label>
                      <select
                        class="form-control form-select"
                        aria-label="Default select"
                        id="banner_type"
                        v-model="banner.banner_type"
                      >
                        <option :value="1">نص</option>
                        <option :value="2">صورة</option>
                        <option :value="3">نص وصورة</option>
                      </select>
                    </div>
                  </div>
                  <!-- Banner Data -->

                  <!-- Text Only -->
                  <Transition name="scale" mode="out-in">
                    <div class="row" v-if="banner.banner_type == 1">
                      <div class="col-12">
                        <!-- Banner Title -->
                        <div class="form-group">
                          <label for="bannerTitle">العنوان</label>
                          <textarea
                            class="form-control"
                            id="bannerTitle"
                            placeholder="العنوان"
                            required
                            v-model="banner.title"
                            rows="3"
                            cols="5"
                            maxlength="70"
                          ></textarea>
                        </div>
                        <!-- Description -->
                        <div class="form-group">
                          <label for="title">وصف</label>
                          <textarea
                            class="form-control"
                            placeholder="وصف"
                            id="title"
                            cols="30"
                            required
                            maxlength="150"
                            v-model="banner.description"
                            rows="6"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </Transition>
                  <!-- Image Only -->
                  <Transition name="scale" mode="out-in">
                    <div class="row" v-if="banner.banner_type == 2">
                      <div class="col-lg-9">
                        <div class="from-group">
                          <label for="">تغيير صورة الاعلان</label>
                          <UploadImages
                            class="form-control"
                            @changed="handleImages"
                            :max="1"
                            maxError="يمكنك رفع صورة واحدة لكل اعلان"
                            fileError="لا يمكن رفع ملفات غير الصور"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="from-group">
                          <label for="">صورة الاعلان الحالية</label>
                          <div
                            data-bs-toggle="modal"
                            data-bs-target="#showImageModal"
                            class="img__have mt-2"
                            v-if="banner.image_url"
                          >
                            <img
                              :src="banner.image_url"
                              class="img-fluid"
                              alt="banner image"
                            />

                            <div
                              class="modal fade showImage"
                              id="showImageModal"
                              tabindex="-1"
                              aria-labelledby="showImageModalLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                  <div class="modal-body">
                                    <button
                                      type="button"
                                      class="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>

                                    <img
                                      :src="banner.image_url"
                                      class="img-fluid"
                                      alt="post image"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="img__container mt-2" v-else>
                            <span>لا توجد صورة</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition>
                  <!-- Text and Image -->
                  <Transition name="scale" mode="out-in">
                    <div class="row" v-if="banner.banner_type == 3">
                      <!-- Banner Data -->
                      <div class="col-lg-8">
                        <!-- Banner Title -->
                        <div class="form-group">
                          <label for="bannerTitle">العنوان</label>
                          <textarea
                            class="form-control"
                            id="bannerTitle"
                            placeholder="العنوان"
                            required
                            v-model="banner.title"
                            rows="3"
                            cols="5"
                            maxlength="200"
                          ></textarea>
                        </div>
                        <!-- Description -->
                        <div class="form-group">
                          <label for="title">وصف</label>
                          <textarea
                            class="form-control"
                            placeholder="وصف"
                            id="title"
                            cols="30"
                            required
                            maxlength="250"
                            v-model="banner.description"
                            rows="6"
                          ></textarea>
                        </div>
                      </div>
                      <!-- Banner Image -->
                      <div class="col-lg-4">
                        <div class="row">
                          <div class="col-12">
                            <div class="from-group">
                              <label for="">تغيير صورة الاعلان</label>
                              <UploadImages
                                class="form-control"
                                @changed="handleImages"
                                :max="1"
                                maxError="يمكنك رفع صورة واحدة لكل اعلان"
                                fileError="لا يمكن رفع ملفات غير الصور"
                              />
                            </div>
                          </div>
                          <div class="col-12 mt-2">
                            <div class="from-group">
                              <label for="">صورة الاعلان الحالية</label>
                              <div
                                data-bs-toggle="modal"
                                data-bs-target="#showImageModal"
                                class="img__have mt-2"
                                v-if="banner.image_url"
                              >
                                <img
                                  :src="banner.image_url"
                                  class="img-fluid"
                                  alt="banner image"
                                />

                                <div
                                  class="modal fade showImage"
                                  id="showImageModal"
                                  tabindex="-1"
                                  aria-labelledby="showImageModalLabel"
                                  aria-hidden="true"
                                >
                                  <div
                                    class="modal-dialog modal-dialog-centered"
                                  >
                                    <div class="modal-content">
                                      <div class="modal-body">
                                        <button
                                          type="button"
                                          class="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        ></button>

                                        <img
                                          :src="banner.image_url"
                                          class="img-fluid"
                                          alt="post image"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="img__container mt-2" v-else>
                                <span>لا توجد صورة</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary">حفظ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// Vuex Store

import { mapActions } from "vuex";

// Upload Image
import UploadImages from "vue-upload-drop-images";

import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      banner_id: this.$route.params.id,
      file: null,
      banner: {
        title: "",
        image_url: "",
        description: "",
        banner_type: 0,
        content_dynamic_link: null,
      },
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("bannersModule", ["getBannerById", "updateBanner"]),

    // Add New Banner
    async updateSelectedBanner() {
      if (this.banner.banner_type == 1 && this.banner.image_url != "") {
        deleteFileFromUrl(this.banner.image_url);
        this.banner.image_url = "";
      } else if (this.banner.banner_type == 2) {
        this.banner.title = "";
        this.banner.description = "";
      }

      if (this.file !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع الصورة الان",
            file: this.file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.banner.image_url = url ?? "";
              console.log("show", url);
              toast.dismiss(toastId);
              this.updateBanner(this.banner);
              this.clearAndShowSuccess();
              this.$router.push("/banners");
            },
          },
        };
        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.updateBanner(this.banner);
        this.$router.push("/banners");
        this.clearAndShowSuccess();
      }
    },

    async uploadFile() {},

    // Upload Thumbnail
    async uploadThumbnail() {},

    //-----------------------------------------------------//
    // Add thumbnail Banner
    handleImages(files) {
      this.file = files[0];
    },
    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      this.banner = {};
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم تعديل الاعلان بنجاح",
      });
    },
    // All Two functions
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    //---------------------//
  },
  async created() {
    this.banner = await this.getBannerById(this.banner_id);
    console.log("banner", this.banner);
  },
  computed: {},
  mounted() {},
};
</script>
<style>
</style>